export class ApplicationError extends Error {
  constructor(message?: string) {
    // "Error" breaks the prototype chain here.
    super(message);

    // We need to restore it.
    const actualPrototype = new.target.prototype;
    Object.setPrototypeOf(this, actualPrototype);
  }
}

export class ApplicationDefaultError extends ApplicationError {
  constructor(error: Error) {
    super('Something went wrong.');
    this.originalError = error;
  }

  readonly originalError: Error;
}
